export const SIZE = [2, 4, 6];

export const COLOR = {
    BLACK: '#000',
    WHITE: '#FFF',
    RED: '#fb0807',
    BLUE: '#2391d3',
    GREEN: '#00c800',
    ORANGE: '#ff8900',
    PINK: '#fe5ebd',
};

export const ERASERSIZE = [10];

export const ERASERCOLOR = {
    WHITE: '#FFF',
};
